module.exports = __webpack_public_path__ + "static/media/cq_tutti_option.b51dfd82.svg";